/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_Save_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Description" |
*
* @param {Explorer_Info_Description_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_save_button = /** @type {((inputs?: Explorer_Info_Description_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save Description")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save Description")
	return /** @type {LocalizedString} */ ("Save Description")
});